import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormProvider, useForm } from "react-hook-form";
import CoverSettings from "./CoverSettings";
import FileUpload from "./FileUpload";
import StyleAndQuantity from "./StyleAndQuantity";
const Content = ()=>{
    const methods = useForm({
        mode: "onTouched",
        shouldFocusError: true,
        defaultValues: {
            pdfFile: undefined,
            pdfPageCount: 0,
            coverImage: "1",
            coverCustomImage: undefined,
            title: "",
            name: "",
            tel: "",
            color: "흑백",
            binding: "무선",
            message: "",
            quantity: 1
        }
    });
    return /*#__PURE__*/ _jsx(FormProvider, {
        ...methods,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "w-full bg-gray-50 py-3 sm:py-8 gap-3 sm:gap-6 flex flex-col",
            children: [
                /*#__PURE__*/ _jsx(FileUpload, {}),
                /*#__PURE__*/ _jsx(CoverSettings, {}),
                /*#__PURE__*/ _jsx(StyleAndQuantity, {})
            ]
        })
    });
};
export default Content;
